import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24cd5243"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepAdditionalData" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepAdditionalData__title" }, "Дополнительные данные", -1))
const _hoisted_3 = {
  key: 0,
  class: "ExpressTasks mt-2"
}
const _hoisted_4 = { class: "flex items-center mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ExpressTasks__title" }, "Дополнительные задачи", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Необязательно", -1))
const _hoisted_7 = { class: "ExpressTasks__body" }
const _hoisted_8 = {
  key: 0,
  class: "ExpressTasks__state state--loading"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state--text text--loading" }, "Загрузка списка задач...", -1))
const _hoisted_10 = {
  key: 1,
  class: "ExpressTasks__state state--failed"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state--text text--failed" }, " При загрузке списка задач произошла ошибка ", -1))
const _hoisted_12 = {
  key: 1,
  class: "ExpressTasks__list"
}
const _hoisted_13 = { style: {"max-width":"400px"} }
const _hoisted_14 = { class: "flex items-center justify-end mt-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepAdditionalData__title" }, "Дополнительные данные", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.state.is_saved)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          (_ctx.opened)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_checkbox, {
                    label: "Верификация SPARK",
                    value: _ctx.payload.is_spark_verification,
                    "onUpdate:value": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.is_spark_verification) = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCheckboxChange('spark')))
                    ],
                    disabled: _ctx.state.is_loading
                  }, null, 8, ["value", "disabled"]),
                  _createVNode(_component_checkbox, {
                    class: "ml-2",
                    label: "Верификация Kaspi (Для доставок покупателям из Kaspi Магазина)",
                    value: _ctx.payload.is_kaspi_verification,
                    "onUpdate:value": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payload.is_kaspi_verification) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCheckboxChange('kaspi')))
                    ],
                    disabled: _ctx.state.is_loading
                  }, null, 8, ["value", "disabled"])
                ]),
                (_ctx.payload.is_kaspi_verification)
                  ? (_openBlock(), _createBlock(_component_the_input, {
                      key: 0,
                      placeholder: "Номер заказа Kaspi",
                      value: _ctx.payload.verification_invoice_number,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payload.verification_invoice_number) = $event)),
                      "is-invalid": _ctx.state_form$.verification_invoice_number.$error,
                      "validation-errors": _ctx.state_form$.verification_invoice_number.$errors
                    }, null, 8, ["value", "is-invalid", "validation-errors"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_the_input, {
                  placeholder: "Номер накладной заказчика",
                  value: _ctx.payload.verification_invoice_number,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payload.verification_invoice_number) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_the_textarea, {
                  class: "mt-2",
                  disabled: _ctx.disabled,
                  autoheight: "",
                  rows: 4,
                  placeholder: "Комментарий к заказу",
                  value: _ctx.payload.extra_info,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payload.extra_info) = $event)),
                  "is-invalid": _ctx.state_form$.extra_info.$error,
                  "validation-errors": _ctx.state_form$.extra_info.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
                _hoisted_5,
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.data_state.tasks.is_loading || _ctx.data_state.tasks.is_failed)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.data_state.tasks.is_loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_loader, { class: "primary mt-1" }),
                              _hoisted_9
                            ]))
                          : (_ctx.data_state.tasks.is_failed)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _hoisted_11,
                                _createVNode(_component_the_button, {
                                  class: "red text small",
                                  disabled: _ctx.data_state.tasks.is_loading,
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadTasks(1)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Перезагрузить ")
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]))
                            : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data_state.tasks.list, (task) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "list__item",
                            key: task.id
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_13, [
                                (task.id === 2)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(task.title) + " (Сумма доставки х2)", 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(task.title), 1)
                                    ], 64))
                              ]),
                              _createElementVNode("p", null, [
                                (task.id === 2)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(task.price * 2) + " тенге", 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(task.price) + " тенге", 1)
                                    ], 64))
                              ])
                            ]),
                            (_ctx.isChecked(task.id))
                              ? (_openBlock(), _createBlock(_component_the_button, {
                                  key: 0,
                                  class: "red small",
                                  onClick: ($event: any) => (_ctx.removeTask(task.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Удалить ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_the_button, {
                                  key: 1,
                                  class: "primary small",
                                  onClick: ($event: any) => (_ctx.selectTask(task))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Выбрать ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                          ]))
                        }), 128))
                      ]))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_the_button, {
                    class: "primary small text",
                    disabled: _ctx.disabled,
                    onClick: _ctx.emitSubmit
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createTextVNode(" Сохранить ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_the_button, {
              class: "second small text",
              disabled: _ctx.disabled,
              onClick: _ctx.emitReset
            }, {
              default: _withCtx(() => [
                _hoisted_18,
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _createElementVNode("p", null, " Номер накладной заказчика: " + _toDisplayString(_ctx.payload.verification_invoice_number || 'Не указан'), 1),
          _createElementVNode("p", null, "Комментарий к заказу: " + _toDisplayString(_ctx.payload.extra_info || 'Не указаны'), 1),
          _createElementVNode("p", null, "Дополнительные задачи: " + _toDisplayString(_ctx.getTasksString || 'Не указаны'), 1)
        ], 64))
  ]))
}